import { AnalystChartSpec, AnalystTableSpec } from '@digital-twins/shared-types'

import { FeaturedAnalystChart } from './FeaturedAnalystChart'
import { FeaturedAnalystTable } from './FeaturedAnalystTable'

interface ThreadFeaturedExhibitsProps {
  charts?: Array<AnalystChartSpec>
  tables?: Array<AnalystTableSpec>
}

export function ThreadFeaturedExhibits(props: ThreadFeaturedExhibitsProps) {
  const { charts = [], tables = [] } = props

  if (charts.length === 0 && tables.length === 0) {
    return null
  }

  return (
    <div className="flex flex-col gap-4" data-testid="thread-featured-exhibits">
      {tables.map((table, index) => (
        <FeaturedAnalystTable
          key={`${table.title}-${index}`}
          table={table}
          index={index}
        />
      ))}
      {charts.map((chart, index) => (
        <FeaturedAnalystChart
          key={`${chart.title}-${index}`}
          chart={chart}
          index={index}
        />
      ))}
    </div>
  )
}

export function asAnalystCharts(value: unknown): Array<AnalystChartSpec> | undefined {
  if (!Array.isArray(value) || value.length === 0) {
    return undefined
  }
  return value as Array<AnalystChartSpec>
}

export function asAnalystTables(value: unknown): Array<AnalystTableSpec> | undefined {
  if (!Array.isArray(value) || value.length === 0) {
    return undefined
  }
  return value as Array<AnalystTableSpec>
}
